<template>
  <span>
    <span class="label-success label">{{ good }}</span>
    <span class="label-danger label">{{ bad }}</span>
    <span class="label-default label">Total {{ fileData.length }}</span>
  </span>
</template>
<script>
  export default {
    name: 'QuoteBatchLabels',
    props: {
      fileData: {
        type: Array,
        required: true
      }
    },
    computed: {
      good () {
        return this.fileData.filter(({request}) => this.isNumeric(request.MinCost)).length
      },
      bad () {
        return this.fileData.filter(({request}) => {
          return (!this.isNumeric(request.MinCost)) &&
                (request.MinCost !== null)
        }).length
      },
      ugly () {}
    },
    methods: {
      isNumeric (n) {
        return Number(n) === n
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/quote/components/QuoteBatchLabels.vue